import React from 'react';
import {
  Dac7ProfileWrapper,
  StyledLinkParagraph,
  Title,
  Button,
  Text,
  SubTitle,
  EyeHidden,
  BoldText,
  ButtonWrapper,
} from './components/style/Dac7Profile';
import { useI18n } from '../../../../i18n';

interface Props {
  isBlockable: boolean;
  redirectToForm: () => void;
  learnMore: string;
  deadline: string;
}

export default ({ isBlockable, redirectToForm, learnMore, deadline }: Props) => {
  const i18n = useI18n();
  const date = new Date(deadline);
  const day = date.getUTCDate();
  const month = date.getUTCMonth();

  return (
    <Dac7ProfileWrapper>
      <Title>
        {i18n('dlv_dac7_profile_title_details').toUpperCase()} <EyeHidden />
      </Title>
      <SubTitle>
        {i18n('dlv_dac7_profile_fill')} {day} {i18n(`dlv_returns_month_${month}`)}
      </SubTitle>
      <Text>{i18n('dlv_dac7_profile_conditions')}</Text>
      <Text>{i18n('dlv_dac7_profile_regulations')}</Text>
      {!!isBlockable && <BoldText>{i18n('dlv_dac7_profile_required')}</BoldText>}
      <StyledLinkParagraph href={learnMore}>{i18n('dlv_dac7_profile_learn')}</StyledLinkParagraph>
      <ButtonWrapper>
        <Button onClick={redirectToForm}>{i18n('dlv_dac7_profile_fill_form')}</Button>
      </ButtonWrapper>
    </Dac7ProfileWrapper>
  );
};
